<script lang="ts">
  // Die allgemeine PIN-Abfrage (docs/security-hardening.md, "Vault-PIN").
  //
  // Seit 09.10.2026 verlangt der Server die Vault-PIN für alles, was
  // ändert, WAS auf den Rechnern läuft, Geheimnisse zeigt oder Rohdaten
  // herausgibt (internal/api/schutzstufe.go). Das sind Dutzende Aktionen
  // auf vielen Seiten -- jede einzeln mit einer eigenen Eingabe
  // auszustatten, hieße, dass die nächste neue Aktion wieder ohne dasteht.
  //
  // Darum EINE Stelle: antwortet der Server mit 423 und "stufe", meldet
  // lib/pin-stufe.ts das hier (es hängt an fetch selbst), und dieses
  // Fenster legt sich über die Seite. Nach der Eingabe wiederholt der Benutzer seinen
  // Handgriff -- die Aktion von selbst noch einmal auszulösen wäre bei
  // etwas, das einen Stack löscht, genau die falsche Bequemlichkeit.
  //
  // Seiten mit eigenem Tor (Vault, Zeitreise, Dateien, Terminal, Ablage)
  // bekommen 423 OHNE "stufe" und zeigen ihre Eingabe selbst.

  import Kreuz from "./Kreuz.svelte";
  import VaultPinGate from "./VaultPinGate.svelte";
  import { t } from "./i18n.svelte";
  import { PIN_NOETIG } from "./pin-stufe";
  import { portal } from "./portal";
  import { toast } from "./toast.svelte";

  let offen = $state(false);

  $effect(() => {
    const auf = () => (offen = true);
    window.addEventListener(PIN_NOETIG, auf);
    return () => window.removeEventListener(PIN_NOETIG, auf);
  });

  function frei(): void {
    offen = false;
    toast.info(t("pin.stufe.frei", "Freigegeben für 30 Minuten — bitte noch einmal auslösen."));
  }
</script>

<svelte:window onkeydown={(e) => offen && e.key === "Escape" && (offen = false)} />

{#if offen}
  <div
    use:portal
    class="fixed inset-0 z-210 grid place-items-center bg-black/50 p-3 backdrop-blur-sm"
    role="dialog"
    aria-modal="true"
    aria-label={t("pin.stufe.titel", "Geschützte Aktion")}
  >
    <div class="relative w-full max-w-sm">
      <button
        type="button"
        class="text-fg-muted hover:text-fg absolute top-12 right-2 z-10 grid h-8 w-8 place-items-center rounded-md"
        aria-label={t("common.close", "Schließen")}
        onclick={() => (offen = false)}
      >
        <Kreuz />
      </button>
      <VaultPinGate
        title={t("pin.stufe.titel", "Geschützte Aktion")}
        hint={t(
          "pin.stufe.hinweis",
          "Das ändert, was auf den Rechnern läuft, oder zeigt Geheimes. Mit der Vault-PIN ist es 30 Minuten frei.",
        )}
        onunlocked={frei}
      />
    </div>
  </div>
{/if}
